import React from 'react';
import { useExperienceFail } from '@atlassian/jira-experience-tracker/src/ui/experience-fail/index.tsx';
import { ExperienceStart } from '@atlassian/jira-experience-tracker/src/ui/experience-start/index.tsx';
import { ExperienceSuccess } from '@atlassian/jira-experience-tracker/src/ui/experience-success/index.tsx';
import { useProjectContext } from '@atlassian/jira-providers-project-context/src/index.tsx';
import { JIRA_SOFTWARE } from '@atlassian/jira-shared-types/src/application.tsx';
import { useAppEditions } from '@atlassian/jira-tenant-context-controller/src/components/app-editions/index.tsx';

const EXPERIENCE_NAME = 'viewFeatureFlagsEmptyStateExperience';

export const ViewFeatureFlagsEmptyStateExperienceExperienceStart = ({
	experienceId,
}: {
	experienceId: string | null;
}) => {
	const appEditions = useAppEditions();
	return (
		<ExperienceStart
			experienceId={experienceId}
			experience={EXPERIENCE_NAME}
			analyticsSource="featureFlagsEmptyStateExperience"
			edition={appEditions.software}
			application={JIRA_SOFTWARE}
		/>
	);
};

export const useViewFeatureFlagsEmptyStateExperienceExperienceFail = () =>
	useExperienceFail({ experience: EXPERIENCE_NAME });

export const ViewFeatureFlagsEmptyStateExperienceExperienceSuccessTracker = () => {
	const { data: projectContext } = useProjectContext();

	return (
		<ExperienceSuccess
			experience={EXPERIENCE_NAME}
			attributes={
				projectContext != null
					? {
							projectId: projectContext.projectId,
							isProjectAdmin: projectContext.isProjectAdmin,
							simplified: projectContext.simplified,
						}
					: undefined
			}
		/>
	);
};
